import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=25e7c2b0&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=25e7c2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7c2b0",
  null
  
)

export default component.exports